import PendingApplicationsTemplate from "./Template";

const PendingLeaveApplicationsPage = () => (
    <PendingApplicationsTemplate type="leave" isLeave />
);

export default PendingLeaveApplicationsPage;
